export default "__VITE_ASSET__yzQ3l7eA__"